import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "howtos"
    }}>{`HowTos`}</h2>
    <h3 {...{
      "id": "how-to-significantly-speed-up-the-development-process"
    }}>{`How to significantly speed up the development process?`}</h3>
    <ol>
      <li parentName="ol">{`Do it first`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`yarn add -D nodemon
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Then add`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`"start:dev": "nodemon -r esm dist/store/server/index.js"
`}</code></pre>
    <p>{`in the script section file package.json`}</p>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">
        <p parentName="li">{`Open 3 terminals`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`execute commands (each in a separate terminal)`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`yarn build:watch
yarn start-api
yarn start:dev
`}</code></pre>
    <p>{`nodemon views file change and restarts the store`}</p>
    <p>{`"build:watch" first builds everything, and then rebuilds only the changed`}</p>
    <p>{`it does not reload the page in the browser automatically, but significantly
speeds up the development process`}</p>
    <h3 {...{
      "id": "feel-free-to-add-your-howtos"
    }}>{`Feel free to add your HowTos.`}</h3>
    <p>{`You can add it by making Pull Request to the
`}<a parentName="p" {...{
        "href": "https://github.com/Cezerin3/Documentation"
      }}>{`https://github.com/Cezerin3/Documentation`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      